import * as _ from 'underscore';
import { FlowBaseWithUsageInfo } from '../models/FlowInfo';
import { IFavoriteItem, IItemStatisticsInfo } from '../models/resourceInfoParts';
import { Module } from '../Module';
import { Favorites } from '../resources/Favorites';
import { IUsageInfo } from '../ServerApi/types/IUsageInfo';

export class FavoriteService {

  public static $inject = [
    '$log',
    'Favorites'
  ];

  constructor(
    private $log: ng.ILogService,
    private Favorites: Favorites) {}

  private incrementFavorite<U extends IUsageInfo>(item: IFavoriteItem & IItemStatisticsInfo<U>) {
    if (_.isNumber(item.usageInfo.favoritesTotal)) { item.usageInfo.favoritesTotal++; }
    item.favorite = true;
  }

  private decrementFavorite<U extends IUsageInfo>(item: IFavoriteItem & IItemStatisticsInfo<U>) {
    if (_.isNumber(item.usageInfo.favoritesTotal)) { item.usageInfo.favoritesTotal--; }
    item.favorite = false;
  }

  private failedAdd<U extends IUsageInfo>(contentType: string, item: IFavoriteItem & IItemStatisticsInfo<U>, error: number) {
    this.$log.log('Adding favorite to ', contentType, ' failed at the server: error code ', error);
    this.decrementFavorite(item);
    return false;
  }

  private failedRemove<U extends IUsageInfo>(contentType: string, item: IFavoriteItem & IItemStatisticsInfo<U>, error: number) {
    this.$log.log('Removing favorite from ', contentType, ' failed at the server: error code ', error);
    this.incrementFavorite(item);
    return false;
  }

  public addFavoriteFlow(item: FlowBaseWithUsageInfo): ng.IPromise<boolean> {
    this.incrementFavorite(item);
    return this.Favorites.addFlow(item)
      .then(result => {
        if (result.errors) {
          return this.failedAdd('flow', item, result.errors[0].code);
        }
        return true;
      });
  }

  public removeFavoriteFlow(item: FlowBaseWithUsageInfo): ng.IPromise<boolean> {
    this.decrementFavorite(item);
    return this.Favorites.removeFlow(item)
      .then(result => {
        if (result.errors) {
          return this.failedRemove('flow', item, result.errors[0].code);
        }
        return true;
      });
  }
}

Module.instance().service('FavoriteService', FavoriteService);
